export class ChromecastSessionManager {
  public loadMedia(loadRequest: chrome.cast.media.LoadRequest): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const session = this.getSession();

      if (!session) {
        resolve();

        return;
      }

      session.getSessionObj().loadMedia(loadRequest, () => resolve(), reject);
    });
  }

  public editTracksInfo(
    request: chrome.cast.media.EditTracksInfoRequest
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const media = this.getMedia();

      if (!media) {
        resolve(false);

        return;
      }

      media.editTracksInfo(
        request,
        () => {
          resolve(
            request.activeTrackIds.length === media.activeTrackIds?.length &&
              request.activeTrackIds.every((trackId) =>
                media.activeTrackIds?.includes(trackId)
              )
          );
        },
        reject
      );
    });
  }

  public disconnect(): void {
    try {
      this.getSession()?.endSession(true);
    } catch {
      // noop
    }
  }

  public getCastContext() {
    return cast.framework.CastContext.getInstance();
  }

  public getSession() {
    return this.getCastContext().getCurrentSession();
  }

  public getSessionState() {
    return this.getSession()?.getSessionState();
  }

  public getMedia() {
    const session = this.getSession();

    if (!session) {
      return null;
    }

    return session.getMediaSession();
  }
}
